import request from '@/utils/request'
import qs from 'qs'

export async function getDestination(params:any): Promise<any>{
    console.log('paramsparamsparams',params)
    return request({
        url: '/seller/v1/product/getList',
        method: 'POST',
        data:params
    })
}